export const IMAGE_SIZES_PROP = '70vmin';
export const imagePreloadCache = new Map();
export const getSrcSet = (src, quality, width, loader, loaderOptions, priority) => {
    const sizes = [Math.floor(width / 2), width, Math.floor(width * 2)].filter(w => w > 0);
    const srcSet = sizes
        .map(w => `${loader({ width: w, src, quality, options: loaderOptions })} ${w}w`)
        .join(', ');
    if (priority) {
        setImagePreload({
            href: src,
            srcSet,
            fetchPriority: 'high'
        });
    }
    return srcSet;
};
export const getInt = (x) => {
    if (typeof x === 'number') {
        return x;
    }
    if (typeof x === 'string' && /^\d+$/.test(x)) {
        return Number.parseInt(x, 10);
    }
    return Number.NaN;
};
export const isStaticRequire = (src) => src.default !== undefined;
export const isStaticImport = (src) => typeof src === 'object' && isStaticRequire(src);
export const setImagePreload = (attributes) => {
    if (typeof window !== 'undefined') {
        return;
    }
    const key = Object.values(attributes).join('|');
    imagePreloadCache.set(key, attributes);
};
export const getImagePreloadLinksString = () => [...imagePreloadCache.values()]
    .map((attributes, i) => {
    const { href, srcSet, media, fetchPriority } = attributes;
    return `<link rel="preload" fetchpriority="${(fetchPriority !== null && fetchPriority !== void 0 ? fetchPriority : i === 0) ? 'high' : 'auto'}" as="image" href="${href}" imagesrcset="${srcSet}" ${media ? `media="${media}"` : `imagesizes="${IMAGE_SIZES_PROP}"`}></link>`;
})
    .join('');
export const resetImagePreloadCache = () => {
    imagePreloadCache.clear();
};
